
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes02 as ObiDiodes02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-02.js';
 
 
 

 
 export const ObiDiodes02 = createComponent({
   react: React,
   tagName: 'obi-diodes-02',
   elementClass: ObiDiodes02Element,
   events: {
     
   }
  });
 
 